export default "__VITE_ASSET__7e555ea0__"